export default (value) => {
  return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(value)
}


// WEBPACK FOOTER //
// ./src/validator/email.js